import classNames from 'classnames';
import React, { memo } from 'react';

import { HEADER_HEIGHT } from '../../../../constants/common';

import styles from './table-of-content.module.scss';

interface ITableParams {
  articleContent: HTMLDivElement;
  articleIndex: number;
}

export const TableOfContent = memo<ITableParams>(({ articleContent, articleIndex }) => {
  const titlesList = articleContent?.getElementsByTagName('h2');

  const titlesArr = titlesList && Array.from(titlesList);

  if (!articleContent || !titlesArr?.length) return null;

  const handleScroll = (target) => {
    // пингуем кат который в сетке
    const spoiler = document.querySelector('[data-stk-plugin="test-01--spoiler--spoiler@0.6"]');
    if (spoiler) {
      spoiler.classList.add('stk-plugin-spoiler--open');
    }

    // удляем кнопку "Читать дальше"
    const buttonSpoiler = document.querySelector('button[data-is-spoiler-listener]');
    if (buttonSpoiler) {
      buttonSpoiler.nextElementSibling['style'].cursor = 'unset';
      buttonSpoiler.remove();
    }

    // скроллим к выбранному заголовку через 1 милисекунду
    setTimeout(() => {
      const scrollTo = target.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT;
      window.scrollTo({ top: scrollTo, behavior: 'smooth' });
    }, 100);
  };

  const renderTitlesList = () => {
    return titlesArr.map((title, i) => {
      const target = titlesList[i];

      return (
        <div className={styles.item} onClick={() => handleScroll(target)} key={`title-${articleIndex}-${i}`}>
          <span>{title.innerText}</span>
        </div>
      );
    });
  };

  return <div className={classNames(styles.wrapper, 'h-mt-24')}>{renderTitlesList()}</div>;
});
